import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IPathRowProps } from './IPathRowProps';
import { PathForm } from './PathForm';
import { PathPalette } from './PathPalette';

/**
 * Рядок шляху (прототип v4 pathRows): відступ 24px на рівень, «●» кореня чи «└», кружок кольору напряму (кнопка палітри; власний колір —
 * з білим кільцем, успадкований — «успадковано»), назва, «Поточний» для ітерації, дати, записи з нащадками, «+ Дочірній», «Перейменувати» /
 * «Редагувати», «Видалити» (крім кореня); під рядком — форма або палітра.
 */
export function PathRow({ row, kind, records, parent, current, dates, editor }: IPathRowProps) {
  const { t } = useTranslation();
  const { node, depth, color, inherited } = row;
  const areas = kind === 'areas';
  const own = areas && !!node.color;
  return (
    <div className={cx('cu-pathrow', current && 'is-current')}>
      <div className={cx('cu-pathgrid', areas ? 'cu-pathgrid--areas' : 'cu-pathgrid--iters')}>
        <span className="cu-path" style={{ paddingLeft: depth * 24 }}>
          <span className="cu-path__elbow" aria-hidden="true">{depth === 0 ? '●' : '└'}</span>
          {areas && <button type="button" className="cu-path__swatch" disabled={!editor.canEdit} aria-label={t('sysCust.paths.chooseColour')} title={t('sysCust.paths.colour')}
            style={{ background: color ?? 'transparent', borderColor: own ? '#ffffff' : color ?? 'var(--line2)', boxShadow: own ? `0 0 0 1.5px ${node.color}` : undefined }}
            onClick={() => editor.togglePalette(node)} />}
          <span className={cx('cu-ellipsis', depth === 0 ? 'cu-path__root' : depth === 1 ? 'cu-path__name' : 'cu-path__leaf')}>{node.name}</span>
          {current && <span className="cu-path__current">{t('sysCust.paths.current')}</span>}
          {areas && inherited && depth > 0 && <span className="cu-path__note">{t('sysCust.paths.inherited')}</span>}
        </span>
        {!areas && <span className="sp-muted cu-path__dates">{dates}</span>}
        <span className="sp-mono">{records ?? '…'}</span>
        <span className="sp-actions">
          <button type="button" className="sp-btn cu-pathbtn" disabled={!editor.canEdit} onClick={() => editor.startAdd(node)}>{t('sysCust.paths.child')}</button>
          <button type="button" className="sp-btn cu-pathbtn" disabled={!editor.canEdit} onClick={() => editor.startEdit(node)}>{t(areas ? 'sysCust.paths.rename' : 'sysCust.paths.edit')}</button>
          {depth > 0 && <button type="button" className="sp-btn sp-btn--danger cu-pathbtn" disabled={!editor.canEdit} onClick={() => editor.remove(node, records ?? 0, parent)}>{t('sysCust.paths.delete')}</button>}
        </span>
      </div>
      {editor.palette === node.id && <PathPalette node={node} depth={depth} editor={editor} />}
      {editor.edit?.nodeId === node.id && <PathForm node={node} depth={depth} kind={kind} editor={editor} />}
    </div>
  );
}
